import { Heading, Spacer } from '@sparemin/blockhead';
import React from 'react';
import { Alert } from 'components/icons';
import SocialShareModalBody from 'containers/SocialShareModal/SocialShareModalBody';

export type YouTubeDisallowedAccountStepProps = {};

const YouTubeDisallowedAccountStep: React.FC<YouTubeDisallowedAccountStepProps> = () => {
  return (
    <SocialShareModalBody showRegenerateTextButton={false}>
      <Spacer
        orientation="vertical"
        justify="center"
        align="center"
        space="14px"
      >
        <Alert height={100} width={100} />

        <Heading level={2} align="center">
          YouTube flagged your account because it violated their community
          guidelines. Please switch to another account, otherwise they may block
          your videos.
        </Heading>
      </Spacer>
    </SocialShareModalBody>
  );
};

export default YouTubeDisallowedAccountStep;
